import './Facebook.css';
import { GrFacebookOption } from 'react-icons/gr';

function Facebook() {
    return (
        <div id="fb-icon">
            <GrFacebookOption />
        </div>
    );
}

export default Facebook;